import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { GetPayments, SetPaymentError, SetPaymentLoading } from '@tsin-core/actions/payment.action';
import { PaymentModel, PaymentStateModel } from '@tsin-core/models/payment.model';
import { PaymentHttpService } from '@tsin-core/services/http/payment-http.service';
import { LogoutAction } from '@tsin-core/actions/auth.action';
import { catchError, tap } from 'rxjs/operators';

@State<PaymentStateModel>({
  name: 'paymentState',
  defaults: {
    payments: [],
    loading: false,
    error: null,
  },
})
@Injectable()
export class PaymentState {
  paymentService: PaymentHttpService = inject(PaymentHttpService);

  @Selector()
  static getPayments(state: PaymentStateModel): PaymentModel[] {
    return state.payments;
  }

  @Selector()
  static getLoading(state: PaymentStateModel): boolean {
    return state.loading;
  }

  @Selector()
  static getError(state: PaymentStateModel): string | null {
    return state.error;
  }

  @Action(GetPayments)
  getPayments(ctx: StateContext<PaymentStateModel>, action: GetPayments) {
    ctx.patchState({ loading: true, error: null });
    return this.paymentService.getPayments(action.payload).pipe(
      tap((result: PaymentModel[]) => {
        ctx.patchState({ payments: result, loading: false });
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 403) {
          ctx.patchState({ payments: [], loading: false, error: null });
          ctx.dispatch(new LogoutAction());
        } else {
          ctx.patchState({ loading: false, error: error.message });
        }
        throw error;
      })
    );
  }

  @Action(SetPaymentLoading)
  setLoading(ctx: StateContext<PaymentStateModel>, action: SetPaymentLoading) {
    ctx.patchState({ loading: action.loading });
  }

  @Action(SetPaymentError)
  setError(ctx: StateContext<PaymentStateModel>, action: SetPaymentError) {
    ctx.patchState({ error: action.error });
  }
}
